import { schema } from "normalizr";

const LeaveTypeSchema = new schema.Entity("leaveTypes");
const LeaveTypeArraySchema = new schema.Array(LeaveTypeSchema);

export { LeaveTypeSchema, LeaveTypeArraySchema };